import type { IconSvgObject } from './types';

const VestIcon: IconSvgObject = [
  ["path", { d: "M9 2H15", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M6 3.5L9 2L13.594 12.5662C13.8491 13.1529 13.8081 13.8262 13.4837 14.3777L9 22L4 20V11C7 8.5 6.5 4.5 6 3.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12 9L15.0005 2L18.0005 3.5C17.5005 4.5 17.0005 8.5 20.0005 11V20L15.0005 22L12 17", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M10.625 13.5H10.5M10.75 13.5C10.75 13.6381 10.6381 13.75 10.5 13.75C10.3619 13.75 10.25 13.6381 10.25 13.5C10.25 13.3619 10.3619 13.25 10.5 13.25C10.6381 13.25 10.75 13.3619 10.75 13.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default VestIcon;
